import { Injectable } from '@angular/core';
import {CreateModalService} from './createModal.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryModalService extends CreateModalService {
}
